<template>
  <!-- 民办非资产负债表 -->
  <div class="big_box4">
    <div class="top_title3">
      <h5>资产负债表</h5>
      <div class="bottom_font clearfix">
        <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
        <h6 class="center"><span>{{durationOfTaxTime}}</span></h6>
        <h6 class="right">
          <p>单位：元</p>
          <p>纳税人识别号：<span>{{taxNo}}</span></p>
        </h6>
      </div>
    </div>
    <table class="content" cellspacing="0" width="100%" >
      <tr class="top_bg">
        <td class="center" style="width:21%;">资产</td>
        <td class="center" style="width:4%;">行次</td>
        <td class="center" style="width:12%;">年初余额</td>
        <td class="center" style="width:12%;">期末余额</td>
        <td class="center" style="width:21%;">负债和净资产</td>
        <td class="center" style="width:4%;">行次</td>
        <td class="center" style="width:12%;">年初余额</td>
        <td class="center" style="width:12%;">期末余额</td>
      </tr>
    </table>
    <div class="fixed_box_table" :style="{height:contentStyleObj}">
      <table class="content" cellspacing="0">
        <tr>
          <td style="width:21%;" class="weight">流动资产：</td>
          <td class="center" style="width:4%;"></td>
          <td style="width:12%;"><span></span></td>
          <td style="width:12%;"><span></span></td>
          <td style="width:21%;" class="weight">流动负债：</td>
          <td style="width:4%;" class="center"></td>
          <td style="width:12%;"><span></span></td>
          <td style="width:12%;"><span></span></td>
        </tr>

        <tr>
          <td class="left_k">货币资金</td>
          <td class="center">1</td>
          <qzf-td :disabled="false" v-model:amount="list[0].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[0].qmyeZc" @change="changeList()"></qzf-td>

          <td class="left_k">短期借款</td>
          <td class="center">30</td>
          <qzf-td :disabled="false" v-model:amount="list[0].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[0].qmyeQy" @change="changeList()"></qzf-td>

        </tr>

        <tr>
          <td class="left_k">短期投资</td>
          <td class="center">2</td>
          <qzf-td :disabled="false" v-model:amount="list[1].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[1].qmyeZc" @change="changeList()"></qzf-td>

          <td class="left_k">应付款项</td>
          <td class="center">31</td>
          <qzf-td :disabled="false" v-model:amount="list[1].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[1].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">应收款项</td>
          <td class="center">3</td>
          <qzf-td :disabled="false" v-model:amount="list[2].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[2].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">应付工资</td>
          <td class="center">32</td>
          <qzf-td :disabled="false" v-model:amount="list[2].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[2].qmyeQy" @change="changeList()"></qzf-td>
        </tr>

        <tr>
          <td class="left_k">预付账款</td>
          <td class="center">4</td>
          <qzf-td :disabled="false" v-model:amount="list[3].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[3].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">应交税金</td>
          <td class="center">33</td>
          <qzf-td :disabled="false" v-model:amount="list[3].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[3].qmyeQy" @change="changeList()"></qzf-td>
        </tr>

        <tr>
          <td class="left_k">存   货</td>
          <td class="center">5</td>
          <qzf-td :disabled="false" v-model:amount="list[4].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[4].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">预收账款</td>
          <td class="center">34</td>
          <qzf-td :disabled="false" v-model:amount="list[4].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[4].qmyeQy" @change="changeList()"></qzf-td>
        </tr>

        <tr>
          <td class="left_k">待摊费用</td>
          <td class="center">6</td>
          <qzf-td :disabled="false" v-model:amount="list[5].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[5].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">预提费用</td>
          <td class="center">35</td>
          <qzf-td :disabled="false" v-model:amount="list[5].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[5].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">一年内到期的长期债权投资</td>
          <td class="center">7</td>
          <qzf-td :disabled="false" v-model:amount="list[6].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[6].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">预计负债</td>
          <td class="center">36</td>
          <qzf-td :disabled="false" v-model:amount="list[6].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[6].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">其他流动资产</td>
          <td class="center">8</td>
          <qzf-td :disabled="false" v-model:amount="list[7].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[7].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">一年内到期的长期负债</td>
          <td class="center">37</td>
          <qzf-td :disabled="false" v-model:amount="list[7].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[7].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        
        <tr>
          <td class="weight">流动资产合计</td>
          <td class="center">9</td>
          <qzf-td :disabled="false" v-model:amount="list[8].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[8].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">其他流动负债</td>
          <td class="center">38</td>
          <qzf-td :disabled="false" v-model:amount="list[8].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[8].qmyeQy" @change="changeList()"></qzf-td>
        </tr>

        <tr>
          <td></td>
          <td class="center">10</td>
          <td></td>
          <td></td>
          <td class="weight">流动负债合计</td>
          <td class="center">39</td>
          <qzf-td :disabled="false" v-model:amount="list[9].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[9].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="weight">长期投资：</td>
          <td class="center">11</td>
          <td></td>
          <td></td>
          <td></td>
          <td class="center">40</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="left_k">长期股权投资</td>
          <td class="center">12</td>
          <qzf-td :disabled="false" v-model:amount="list[11].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[11].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">长期负债：</td>
          <td class="center">41</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="left_k">长期债权投资</td>
          <td class="center">13</td>
          <qzf-td :disabled="false" v-model:amount="list[12].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[12].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">长期借款</td>
          <td class="center">42</td>
          <qzf-td :disabled="false" v-model:amount="list[12].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[12].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="weight">长期投资合计</td>
          <td class="center">14</td>
          <qzf-td :disabled="false" v-model:amount="list[13].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[13].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">长期应付款</td>
          <td class="center">43</td>
          <qzf-td :disabled="false" v-model:amount="list[13].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[13].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td></td>
          <td class="center">15</td>
          <td></td>
          <td></td>
          <td class="left_k">其他长期负债</td>
          <td class="center">44</td>
          <qzf-td :disabled="false" v-model:amount="list[14].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[14].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="weight">固定资产：</td>
          <td class="center">16</td>
          <qzf-td :disabled="false" v-model:amount="list[15].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[15].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">长期负债合计</td>
          <td class="center">45</td>
          <qzf-td :disabled="false" v-model:amount="list[15].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[15].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">固定资产原价</td>
          <td class="center">17</td>
          <qzf-td :disabled="false" v-model:amount="list[16].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[16].qmyeZc" @change="changeList()"></qzf-td>
          <td></td>
          <td class="center">46</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="left_k">减：累计折旧</td>
          <td class="center">18</td>
          <qzf-td :disabled="false" v-model:amount="list[17].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[17].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">受托代理负债：</td>
          <td class="center">47</td>
          <td></td>
          <td></td>
        </tr>

         <tr>
          <td class="left_k">固定资产净值</td>
          <td class="center">19</td>
          <qzf-td :disabled="false" v-model:amount="list[18].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[18].qmyeZc" @change="changeList()"></qzf-td>
          <td class="left_k">受托代理负债</td>
          <td class="center">48</td>
          <qzf-td :disabled="false" v-model:amount="list[18].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[18].qmyeQy" @change="changeList()"></qzf-td>
        </tr>


         <tr>
          <td class="left_k">在建工程</td>
          <td class="center">20</td>
          <qzf-td :disabled="false" v-model:amount="list[19].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[19].qmyeZc" @change="changeList()"></qzf-td>
          <td></td>
          <td class="center">49</td>
          <td></td>
          <td></td>
        </tr>

        <tr>
          <td class="left_k">文物文化资产</td>
          <td class="center">21</td>
          <qzf-td :disabled="false" v-model:amount="list[20].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[20].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">负债合计</td>
          <td class="center">50</td>
          <qzf-td :disabled="false" v-model:amount="list[20].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[20].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">固定资产清理</td>
          <td class="center">22</td>
          <qzf-td :disabled="false" v-model:amount="list[21].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[21].qmyeZc" @change="changeList()"></qzf-td>
          <td></td>
          <td class="center">51</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="weight">固定资产合计</td>
          <td class="center">23</td>
          <qzf-td :disabled="false" v-model:amount="list[22].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[22].qmyeZc" @change="changeList()"></qzf-td>
          <td></td>
          <td class="center">52</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="weight">无形资产：</td>
          <td class="center">24</td>
          <td></td>
          <td></td>
          <td></td>
          <td class="center">53</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="left_k">无形资产</td>
          <td class="center">25</td>
          <qzf-td :disabled="false" v-model:amount="list[24].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[24].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">净资产：</td>
          <td class="center">54</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td class="center">26</td>
          <td></td>
          <td></td>
          <td class="left_k">非限定性净资产</td>
          <td class="center">55</td>
          <qzf-td :disabled="false" v-model:amount="list[25].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[25].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="weight">受托代理资产：</td>
          <td class="center">27</td>
          <td></td>
          <td></td>
          <td class="left_k">限定性净资产</td>
          <td class="center">56</td>
          <qzf-td :disabled="false" v-model:amount="list[26].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[26].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">受托代理资产</td>
          <td class="center">28</td>
          <qzf-td :disabled="false" v-model:amount="list[27].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[27].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">净资产合计</td>
          <td class="center">57</td>
          <qzf-td :disabled="false" v-model:amount="list[27].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[27].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
        <tr>
          <td class="weight">资产总计</td>
          <td class="center">29</td>
          <qzf-td :disabled="false" v-model:amount="list[28].ncyeZc" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[28].qmyeZc" @change="changeList()"></qzf-td>
          <td class="weight">负债和净资产总计</td>
          <td class="center">58</td>
          <qzf-td :disabled="false" v-model:amount="list[28].ncyeQy" @change="changeList()"></qzf-td>
          <qzf-td :disabled="false" v-model:amount="list[28].qmyeQy" @change="changeList()"></qzf-td>
        </tr>
      </table>
    </div>
    <div class="save_box">
      <qzf-button type="primary" size="small" plain @click="saveZcfz">保存</qzf-button>
    </div>
  </div>
</template>

<script>
import { gsInfo , gsEdit} from '@/api/taxCalculation.js'

export default {
  name: 'balanceBusiness',
  components: { },
  data() {
    return {
      fullscreenLoading: false,
      durationOfTaxTime: '',
      list:[{"id":156,"kjMainId":14,"type":1,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":157,"kjMainId":14,"type":2,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":158,"kjMainId":14,"type":3,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":159,"kjMainId":14,"type":4,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":160,"kjMainId":14,"type":5,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":161,"kjMainId":14,"type":6,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":162,"kjMainId":14,"type":7,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":163,"kjMainId":14,"type":8,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":164,"kjMainId":14,"type":9,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":165,"kjMainId":14,"type":10,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":166,"kjMainId":14,"type":11,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":167,"kjMainId":14,"type":12,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":168,"kjMainId":14,"type":13,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":169,"kjMainId":14,"type":14,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":170,"kjMainId":14,"type":15,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":171,"kjMainId":14,"type":16,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":172,"kjMainId":14,"type":17,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":173,"kjMainId":14,"type":18,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":174,"kjMainId":14,"type":19,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":175,"kjMainId":14,"type":20,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":176,"kjMainId":14,"type":21,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":177,"kjMainId":14,"type":22,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":178,"kjMainId":14,"type":23,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":179,"kjMainId":14,"type":24,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":180,"kjMainId":14,"type":25,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":181,"kjMainId":14,"type":26,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":182,"kjMainId":14,"type":27,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":183,"kjMainId":14,"type":28,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":184,"kjMainId":14,"type":29,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":185,"kjMainId":14,"type":30,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":186,"kjMainId":14,"type":31,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0}],
      contentStyleObj:{}, //高度变化
      comName:this.$store.getters['user/comInfo'].comName,
      taxNo:this.$store.getters['user/comInfo'].taxNo,
    }
  },
  created() {
    // 获取窗口高度
    this.contentStyleObj=this.$getHeight(356)
  },
  methods: {
    getList(){
      let param = {
        tableName: 'kj_zcfz',
      }
      gsInfo(param).then(res=>{
        if(res.data.data.info){
          this.list = res.data.data.info
          this.durationOfTaxTime = res.data.data.time
          this.comName = res.data.data.name
          this.taxNo = res.data.data.taxNo
        }
      })
    },
    saveZcfz(){
      let param = {
        tableName:'kj_zcfz',
        items:this.list
      }
      gsEdit(param).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("保存成功")
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
 
  span{
    line-height: 28px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 28px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  }
  input{
    width: 100%;
    line-height: 28px;
    padding: 0 6px;
    font-size: 14px;
    padding-right:20px;
  }
}
.left_k{
  text-indent: 2em;
}
.left_b{
  text-indent: 4em;
}
.left_x{
  text-indent:5em;
}
.left_d{
  text-indent:8em;
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h5{
    font-size: 20px;
    color: #333;
    font-weight: 700;
    text-align: center;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    // position: relative;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
      // position: absolute;
      // bottom: 0;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2){
      padding-top: 10px;
    }
  }
}
.center{
  text-align: center;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.weight{
  font-weight: 700;
}
.row_box{
  border-bottom: 1px solid #eee;
}
.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
}
.qsly{
  margin: 4px 5px 0 0;
  float: right;
  color: #666;
  // border: 0;
  // background: #fff;
  cursor: pointer;
}
</style>
